import { CmsApiAccordionBlockData } from 'modules/cms/api/types/CmsApiAccordion';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsAccordionBlock } from 'modules/cms/blocks/Accordion/CmsAccordionBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpAccordionBlock } from './CmsAmpAccordionBlock';

export const CmsAccordionBlockMapping: CmsBlockMapping<CmsApiAccordionBlockData> =
  {
    invariant: [
      {
        prop: 'sections',
        msg: 'Sections required for accordion',
      },
    ],
    width: CmsBlockWidth.INSET,
    Component: CmsAccordionBlock,
    AmpComponent: CmsAmpAccordionBlock,
  };
